import Dialog from "@rio-cloud/rio-uikit/Dialog";
import Button from "@rio-cloud/rio-uikit/Button";
import {useNavigate} from "react-router-dom";

interface Props {
  open: boolean;
  onClose: () => void;
  onAddArea: (type: "INTEREST" | "AVOID") => void;
}

const AddAreas = ({open, onClose, onAddArea}:Props) => {

  return (
    <>
      <Dialog
        show={open}
        title={"Criar área"}
        onClose={onClose}
        className="checkpointDialog"
        showCloseButton
        bsSize="sm"
        body={
          <div className="display-flex flex-column gap-25">
            <div className="display-flex flex-column justify-content-center align-items-center width-100pct border border-color-gray border-width-1 text-center border-style-solid padding-50 gap-20">
              <div
                className="display-flex flex-column justify-content-center align-items-center border border-color-success border-width-3 width-70 height-50 text-center border-style-solid">
                <span className="rioglyph rioglyph-layer text-size-h1 text-color-success"/>
              </div>
              <span className="text-medium text-size-16">Criar área de interesse</span>
              <Button
                bsStyle={Button.PRIMARY}
                iconName=""
                onClick={() => onAddArea("INTEREST")}
              >
                Continuar
              </Button>
            </div>
            <div
              className="display-flex flex-column justify-content-center align-items-center border-style-solid border border-color-gray border-width-1 padding-50 gap-20">
              <div
                className="display-flex flex-column justify-content-center align-items-center border border-color-danger border-width-3 width-70 height-50 text-center border-style-solid">
                <span className="rioglyph rioglyph-layer text-size-h1 text-color-danger"></span>
              </div>
              <span className="text-medium text-size-16">Criar área a ser evitada</span>
              <Button
                bsStyle={Button.PRIMARY}
                iconName=""
                onClick={() => onAddArea("AVOID")}
              >
                Continuar
              </Button>
            </div>
          </div>
        }
      />
    </>
  );
}

export default AddAreas;